export const HAND_SIZE = 14
export const GUESS_MAX = 6
